import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_worldpay_event.js";
//#region src/bite_log_worldpay_event_helper.ts
var bite_log_worldpay_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "terminal-disconnected";
		case 2: return "update-idle-text-error";
		case 3: return "terminal-reboot-request-success";
		case 4: return "terminal-reboot-request-error";
		case 5: return "terminal-idle-text-request-success";
		case 6: return "terminal-idle-text-request-error";
	}
}
//#endregion
export { bite_log_worldpay_event_helper_exports, name };

//# sourceMappingURL=bite_log_worldpay_event_helper.js.map